import {NgModule} from '@angular/core'
import {OfferingPageComponent} from './offering-page.component'
import {TranslocoDirective} from '@ngneat/transloco'
import {BreadcrumbsModule} from '../../../craft/breadcrumbs/breadcrumbs.module'
import {AsyncPipe} from '@angular/common'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {OfferingPageRoutingModule} from './offering-page-routing.module'
import {ProDirectoryByOfferingSectionComponent} from '../../../shared/components/pro-directory-by-offering-section/pro-directory-by-offering-section.component'
import {KnowledgeSectionComponent} from '../../../shared/components/content/knowledge-section/knowledge-section.component'
import {PresentationSectionComponent} from '../../../shared/components/presentation-section/presentation-section.component'
import {ListModule} from '../../../craft/list/list.module'
import {HeroCoverOfferingComponent} from './hero-cover-offering/hero-cover-offering.component'
import {BrandingModule} from '../../../shared/components/branding/branding.module'
import {StartJobProgressiveDisclosureBoxComponent} from '../../../shared/components/domain/job/start-job-progressive-disclosure-box/start-job-progressive-disclosure-box.component'
import {GoogleRatingComponent} from '../../../craft/google-rating/google-rating.component'
import {SupportSectionComponent} from '../../../shared/components/content/support-section/support-section.component'
import {ReviewsSectionComponent} from '../../../shared/components/content/reviews-section/reviews-section.component'
import {LeadSignupSectionComponent} from '../../../shared/components/content/lead-signup-section/lead-signup-section.component'
import {RichTextModule} from '../../../shared/components/rich-text/rich-text.module'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'
import {CraftsmenRegionPagesContentService} from '../../../core/content/services/craftsmen-region-pages-content.service'
import {RelatedItemsSectionComponent} from '../../../shared/components/content/related-items-section/related-items-section.component'
import {MapRelatedOfferingsPipe} from './map-related-offerings.pipe'
import {ReplacePropsPipe} from '../../../shared/pipes/replace-props.pipe'
import {VideoSectionComponent} from '../../../shared/components/content/video-section/video-section.component'

@NgModule({
  imports: [
    HeroCoverOfferingComponent,
    AsyncPipe,
    BreadcrumbsModule,
    TranslocoDirective,
    StartJobProgressiveDisclosureBoxComponent,
    ListModule,
    GoogleRatingComponent,
    FaIconComponent,
    BrandingModule,
    ReviewsSectionComponent,
    SupportSectionComponent,
    ProDirectoryByOfferingSectionComponent,
    KnowledgeSectionComponent,
    PresentationSectionComponent,
    OfferingPageRoutingModule,
    LeadSignupSectionComponent,
    RichTextModule,
    ContentSectionComponent,
    RelatedItemsSectionComponent,
    MapRelatedOfferingsPipe,
    ReplacePropsPipe,
    VideoSectionComponent,
  ],
  declarations: [OfferingPageComponent],
  providers: [CraftsmenRegionPagesContentService],
})
export class OfferingPageModule {}
